var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-api-history-detail"},[_c('el-row',[_c('el-col',[(_vm.tool.codeKebab === 'google-cv')?_c('h2',[_vm._v(" Google API送信履歴 詳細ログ ")]):_vm._e()])],1),_c('el-row',[_c('el-col',[(_vm.tool.codeKebab === 'google-cv')?_c('GoogleLogTable',{attrs:{"googleApiHistoryId":_vm.historyId,"pageType":'default'}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }